<template>
  <div v-if="events.length != null">
    <div class="text-left">
      <!-- <span>Current Month</span> -->
      <!-- <v-chip class="ma-2" color="accent">
        <v-avatar left>
          <v-icon>event</v-icon>
        </v-avatar>
        Current Month &nbsp;&nbsp; {{ title }}
      </v-chip>
      <v-chip class="ma-2" color="accent" @click="setToday">
       
        Today
      </v-chip> -->
      <v-chip class="ma-2" color="accent">
        <v-avatar left>
          <v-icon>event</v-icon>
        </v-avatar>
        <span v-if="curr_month != null"> {{ curr_month }} </span>
        <span v-else> {{ title }} </span>
      </v-chip>
      <v-chip class="ma-2" color="brand onBrand--text" @click="setToday"
        >Go To Today
      </v-chip>
    </div>
    <v-sheet tile color="grey lighten-3">
      <v-row justify="center" style="margin-left: 10px; margin-right: 10px">
        <!-- <v-btn icon class="ma-2" @click="$refs.calendar.prev()"> -->
        <v-btn icon class="ma-2" @click="prev()">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-select
          v-model="type"
          :items="types"
          dense
          outlined
          hide-details
          class="ma-2"
          label="type"
        ></v-select>

        <v-select
          v-model="weekday"
          :items="weekdays"
          dense
          outlined
          hide-details
          label="weekdays"
          class="ma-2"
        ></v-select>

        <!-- <v-btn icon class="ma-2" @click="$refs.calendar.next()"> -->
        <v-btn icon class="ma-2" @click="next()">
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </v-row>
    </v-sheet>
    <v-sheet height="400">
      <v-calendar
        ref="calendar"
        v-model="value"
        :weekdays="weekday"
        :type="type"
        :events="events"
        :event-overlap-threshold="30"
        :event-color="getEventColor"
        @change="getEvents"
        @click:event="showEvent"
        @click:day="getdata"
        @click:more="viewDay"
      ></v-calendar>
    </v-sheet>
    <template>
      <div class="text-center">
        <v-dialog v-model="dialog" width="500">
          <v-card>
            <v-card-title class="headline" primary-title>
              {{ tempevents.name }}
            </v-card-title>

            <v-card-text>
              <div class="headline mb-2">
                Description : {{ tempevents.description }}
              </div>
              <v-chip class="mr-2" color="lightgreen" text-color="white">
                <v-icon left>mdi-brightness-5</v-icon>
                Class: {{ tempevents.std }}
              </v-chip>
              <v-chip class="mr-2" color="lightgreen" text-color="white">
                <v-icon left>mdi-brightness-5</v-icon>
                Division: {{ tempevents.div }}
              </v-chip>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="dialog = false">
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>
  </div>
</template> 

<script>
import axios from "axios";
export default {
  props: ["events"], // from app.vue
  data: () => ({
    title1: "",
    dialog: false,
    datetime: null,
    title: "",
    type: "month",
    types: ["month", "week", "day"],
    mode: "stack",
    modes: ["stack", "column"],
    weekday: [0, 1, 2, 3, 4, 5, 6],
    weekdays: [
      { text: "Sun - Sat", value: [0, 1, 2, 3, 4, 5, 6] },
      { text: "Mon - Sun", value: [1, 2, 3, 4, 5, 6, 0] },
      { text: "Mon - Fri", value: [1, 2, 3, 4, 5] },
    ],
    value: "",
    tempevents: { name: "", description: "", std: "", div: "" },
    colors: [
      "blue",
      "indigo",
      "deep-purple",
      "cyan",
      "green",
      "orange",
      "grey darken-1",
    ],
    names: [
      "Meeting",
      "Holiday",
      "PTO",
      "Travel",
      "Event",
      "Birthday",
      "Conference",
      "Party",
    ],
    months: [
      "",
      "Jan",
      "Feb",
      "Mar",
      "April",
      "May",
      "June",
      "July",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    curr_month: null,
  }),

  updated: function () {
    //console.log("Inside updated");
    this.title = this.getMonthYYYYMMDD(this.$refs.calendar.start);
    this.$nextTick().then(() => {
      if (this.$refs.calendar.value != "") {
        console.log(this.$refs.calendar.value);
        let date = this.$refs.calendar.value;
        var no = date.split("-");
        console.log(no[1]);
        this.curr_month = this.months[parseInt(no[1])];
        console.log(this.curr_month);
      }
    });
  },
  methods: {
    viewDay({ date }) {
      this.value = date;
      this.type = "day";
    },
    prev() {
      console.log("in prev", this.title1);
      // this.title1 = "";
      this.$refs.calendar.prev();
      this.title1 = this.getMonthYYYYMMDD(this.$refs.calendar.value);
      console.log("in prev12", this.title1);
    },
    next() {
      this.$refs.calendar.next();
      this.title1 = this.getMonthYYYYMMDD(this.$refs.calendar.value);
    },
    setToday() {
      this.value = "";
      this.curr_month = null;
    },
    dateTime() {
      let dt = this.formatDate(this.datetime, true);
      const formData = {
        datetime: dt,
      };
      console.log(formData);
      axios
        .post("tryNError/dateTime", formData)
        .then((res) => {
          if (res.data.msg == "200") {
          } else {
          }
        })
        .catch((error) => {
          window.console.log(error);
        });
    },
    showEvent({ nativeEvent, event }) {
      this.tempevents.name = event.name;
      this.tempevents.description = event.description;
      this.tempevents.std = event.std;
      this.tempevents.div = event.div;
      this.dialog = true;
      //alert(event.name + " " + event.description + " " + event.std);
    },
    getdata({ day }) {
      // alert(day)
    },
    getEventData(start) {
      return start == this.value;
    },
    getEvents() {
      //alert(this.value)
    },
    getEventColor(event) {
      return event.color;
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },
    formatDate(a, withTime) {
      return withTime
        ? `${a.getFullYear()}-${
            a.getMonth() + 1
          }-${a.getDate()} ${a.getHours()}:${a.getMinutes()}`
        : `${a.getFullYear()}-${a.getMonth() + 1}-${a.getDate()}`;
    },
    getMonthYYYYMMDD(date) {
      var num_month = date.split("-");
      var months = [
        "",
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      return months[parseInt(num_month[1])];
    },
  },
  mounted() {
    // this.events.push({
    //   name: "Happy New Year", //title
    //   start: "2022-01-01", //this.formatDate(res.data.date, !true),
    //   end: "2022-01-01", //this.formatDate(res.data.date, !true),
    //   color: "",
    //   description: "",
    //   std: "",
    //   div: "",
    // });
    //  this.title = this.getMonthYYYYMMDD(new Date());
  },
};
</script>
